import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth/useAuth';
import type { Capabilities } from '../lib/auth/authTypes';

export function RequireCapability({
  capability,
  children,
}: {
  capability: keyof Capabilities;
  children: React.ReactNode;
}) {
  const { capabilities } = useAuth();
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    // Nur einmal setzen, nicht bei jedem Render
    if (!capabilities[capability]) {
      setShouldRedirect(true);
    }
  }, [capability, capabilities]);

  if (shouldRedirect) {
    // Redirect zur Home-Seite statt einem Alert anzuzeigen,
    // damit der User keine Informationen über geschützte Bereiche erhält.
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
